import "./App.css";

function App() {
	return (
		<div className="BaruSiHoBere">
			<div class="main">
				<div class="mainContent">
					<div class="extras">
						<div class="introdiv">
							<img
								class="logo"
								src={window.location.origin + "/img/BJ_logo2.png"}
								alt="logo"
							/>
						</div>
						<div class="baseInfo">
							<h1>
								Barbora
								<br />&<br />
								Jan
							</h1>
							<div className="date">15. 8. 12:00</div>
						</div>
						<div class="introI">
							<img
								class="i1"
								src={window.location.origin + "/img/i1.jpg"}
								alt="I1"
							/>
							<img
								class="i2"
								src={window.location.origin + "/img/i2.jpg"}
								alt="I2"
							/>
						</div>
					</div>
					<div class="content">
						<div class="contentdiv">
							<h2>Místo</h2>
							<p>
								Celý den zahájíme v pravé poledne obřadem na zámečku. Poté se
								pěšky přesuneme ze zámečku do hostince na oběd a svatební
								oslavu, kde budeme pokračovat až do noci.
							</p>
							<h2>Obřad</h2>
							<p>
								Obřad proběhne na zámečku&nbsp;
								<a
									href="https://maps.app.goo.gl/JQSjupZFcLgzDg1D7"
									target="_blank"
									rel="noreferrer"
								>
									tady
								</a>
								,&nbsp;a nebo taky&nbsp;
								<a
									href="https://mapy.com/s/kudolesafa"
									target="_blank"
									rel="noreferrer"
								>
									tady
								</a>
								. Na místo prosím doražte s dostatečným předstihem, obřad začne
								ve 12:00.
							</p>
						</div>
						<div class="contentdiv">
							<h2>Dress&nbsp;&nbsp;Code</h2>
							<p>
								Dress code je slavnostní – obřad i oběd proběhnou ve formálním
								stylu (pánové sako, dámy šaty). Budeme rádi, pokud v tomto duchu
								zůstanete oblečeni i po zbytek dne a večera, a společně tak
								vytvoříme krásnou atmosféru celé svatby.
							</p>
							<p>
								Předpokládáme, že v půlce srpna bude krásné počasí a většina dne
								proběhne v zahradě hostince. Dámám proto nedoporučujeme boty na
								jehlách.
							</p>
						</div>
						<div class="contentdiv">
							<h2>Dary</h2>
							<p>
								Hrnce už máme, utěrky taky. Největší radost nám udělá vaše
								přítomnost. Pokud byste nás přesto chtěli podpořit, budeme rádi
								za příspěvek na svatební cestu.
							</p>
						</div>
						<div class="contentdiv">
							<h2>Fotky</h2>
							<p>
								Během obřadu prosím nechte své mobily a fotoaparáty v kapse, ať
								si můžeme všichni užít společné chvíle. Fotograf a kameraman se
								o vše postarají a zachytí ty nejkrásnější momenty.
							</p>
							<p>
								Fotky od fotografa a z fotokoutku, stejně jako video, budou k
								dispozici zde, později...
							</p>
						</div>
						<div class="contentdiv">
							<h3>Těšíme se na vás!</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default App;
